<style lang="scss" scoped>
  .dev-pc {
    margin: 0 auto -206px;
    padding: 70px 0 40px;
    width: 1320px;
    max-width: 100%;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.33;
    color: #fff;
    background: #242429;
    border-radius: 20px;

    @include media(max, lg) {
      padding: 50px 0 20px;
      font-size: 16px;
      line-height: 1.38;
    }
  }

  .container {
    margin: 0 auto;
    padding: 0 20px;
    width: 1060px;
    max-width: 100%;
  }

  .title {
    max-width: 520px;
    margin: 0 0 40px;
    font-size: 44px;
    line-height: 1.09;
    font-weight: 600;
    letter-spacing: 0.005em;

    @include media(max, lg) {
      margin-bottom: 30px;
      font-size: 30px;
      line-height: 1.2;
    }
  }

  .wrapper {
    display: flex;
    justify-content: space-between;

    @include media(max, lg) {
      display: block;
    }
  }

  .item {
    position: relative;
    margin-bottom: 30px;
    padding-left: 64px;
    min-height: 48px;

    :global(span) {
      color: #69dc9d;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 48px;
      height: 48px;
      background: no-repeat center;
      background-size: 100% auto;
    }

    [dir=rtl] & {
      padding-left: 0;
      padding-right: 64px;

      &:before {
        left: auto;
        right: 0;
      }
    }

    @include media(max, lg) {
      width: 100%;
    }

    @include media(max, md) {
      :global(br) {
        display: none;
      }
    }

    &_mobile {
      &:before {
        background-image: cdn('images/b2b/pc/icon-mobile.png');

        @media (-webkit-min-device-pixel-ratio: 2),
        (min-resolution: 192dpi) {
          background-image: cdn('images/b2b/pc/icon-mobile@2x.png');
        }
      }
    }

    &_client {
      &:before {
        background-image: cdn('images/b2b/pc/icon-client.png');

        @media (-webkit-min-device-pixel-ratio: 2),
        (min-resolution: 192dpi) {
          background-image: cdn('images/b2b/pc/icon-client@2x.png');
        }
      }
    }

    &_target {
      &:before {
        background-image: cdn('images/b2b/pc/icon-target.png');

        @media (-webkit-min-device-pixel-ratio: 2),
        (min-resolution: 192dpi) {
          background-image: cdn('images/b2b/pc/icon-target@2x.png');
        }
      }
    }
  }
</style>

<template>
  <div class="dev-pc">
    <div class="container">
      <h2 class="title">
        {{$t('title')}}
      </h2>

      <div class="wrapper">
        <div class="item item_mobile" v-html="$t('mobile')"></div>
        <div class="item item_client" v-html="$t('client')"></div>
        <div class="item item_target" v-html="$t('target')"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */

export default {
  name: 'DevPc',
  i18n: {
    messages: {
      ru: {
        title: 'VK Play — не только для ПК-разработчиков',
        mobile: 'Портированная версия приносит <span>10-15%</span> <br>от in-app&nbsp;платежей мобильных версий.',
        client: 'Можно играть через веб, <br>а&nbsp;можно через клиент.',
        target: 'Другой аукцион <br>в&nbsp;закупке рекламы.',
      },
      en: {
        title: 'VK Play isn\'t just for PC developers',
        mobile: 'Ported versions bring <span>10-15%</span> <br>of in-app payments for mobile versions.',
        client: 'You can play via the web <br>or via the client.',
        target: 'A different auction <br>for purchasing ads.',
      },
      de: {
        title: 'VK Play ist nicht nur für PC-Entwickler',
        mobile: 'Portierte Versionen erhöhen In-App-Käufe <br>der Mobile-Versionen um <span>10–15 %</span>',
        client: 'Man kann via Browser <br>oder via Client spielen.',
        target: 'Eine andere Anzeigenauktion <br>zum Kauf von Anzeigen.',
      },
      fr: {
        title: 'VK Play n\'est pas exclusivement destiné aux développeurs PC',
        mobile: 'Les versions portées apportent <span>10-15 %</span> <br>des paiements intégrés pour les versions mobiles.',
        client: 'Vous pouvez jouer via le site Internet <br>ou via le client.',
        target: 'Une enchère différente <br>pour l\'achat de publicités.',
      },
      es: {
        title: 'VK Play no es solo para desarrolladores de PC',
        mobile: 'Las versiones adaptadas aportan un <span>10-15 %</span> <br>de los pagos en la aplicación para las versiones para móviles.',
        client: 'Puedes jugar a través de la web <br>o del cliente.',
        target: 'Una subasta distinta <br>para comprar anuncios.',
      },
      pl: {
        title: 'VK Play nie jest platformą tylko dla twórców gier na PC',
        mobile: 'Przeniesione wersje oprogramowania przynoszą zyski w wys. <span>10–15%</span> płatności w aplikacji wersji mobilnych.',
        client: 'Możliwość gry w przeglądarce <br>lub za pomocą klienta.',
        target: 'Inny typ ofert <br>zakupu reklam.',
      },
      tr: {
        title: 'VK Play, yalnızca PC geliştiricileri için değildir',
        mobile: 'Portlu versiyonlar mobil sürümlerde <br>uygulama içi ödemelerin <span>%10-15</span>\'ini getirir.',
        client: 'Web veya istemci <br>üzerinden oynayabilirsin.',
        target: 'Reklam satın alımında <br>farklı bir açık artırma.',
      },
      ar: {
        title: 'VK Play ليست لمطوري الكمبيوتر فقط',
        mobile: 'الإصدارات المخصصة تحقق <span>10-15%</span> من المدفوعات داخل التطبيق لإصدارات المحمول.',
        client: 'يمكنك اللعب عبر المتصفح <br>أو عبر برنامج العميل.',
        target: 'مزاد مختلف <br>لشراء الإعلانات.',
      },
    },
  },
};

</script>
